import FeatherIconsContainer from "../../components/icon/featherIcons";

const FeatherIcon = () => {
  return <FeatherIconsContainer />;
};

export default FeatherIcon;
